import { Injectable } from '@angular/core';
import { barData } from '../../models/bar-data';

@Injectable({
  providedIn: 'root',
})
export class barService {
  getBarData() {
    return barData;
  }
}